import React, { useState } from 'react'
import AdminPurchaseEntryNew from './AdminPurchaseEntryNew'
import AdminInvoiceEntryNew from './AdminInvoicEntryNew';

const inoviceDefaultValues = {
  skus: [],
  paymentTypes: [],
  invoiceNumber:"",
  invoiceDate: new Date().toISOString().split("T")[0],
  customerName:"",
  Mobile:"",
  TotalFineGold:"",
  advanceamount:"",
  balanceamount:""

};
const AdminCreateInvoiceEntryNew = () => {
  const [editStatus,setEditStatus] = useState(false)

  return (
   <AdminInvoiceEntryNew
   editStatus={editStatus}
   defaultValues={inoviceDefaultValues}
   />
  )
}

export default AdminCreateInvoiceEntryNew
